import hexToRgb from 'assets/theme/function/hex-to-rgb';

function rgba(color: any, opacity: any) {
    return `rgba(${hexToRgb(color)}, ${opacity})`;
}

export default rgba;
